// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const TriangleRight = createIcon(
  <path d="M10.2849 7.42311C9.96994 7.10813 9.43137 7.33121 9.43137 7.77666L9.43137 12.0007L9.43137 16.2248C9.43137 16.6702 9.96994 16.8933 10.2849 16.5783L14.509 12.3543C14.7042 12.159 14.7042 11.8424 14.509 11.6472L10.2849 7.42311Z" />,
);
